var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouterLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6885 4.73828H12.3628C7.36996 4.73828 4.01562 8.24904 4.01562 13.4741V26.0193C4.01562 31.2459 7.36996 34.7583 12.3628 34.7583H25.687C30.6813 34.7583 34.0357 31.2459 34.0357 26.0193V13.4741C34.0357 8.24904 30.6813 4.73828 25.6885 4.73828Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2249 30.448C20.5708 30.448 20.0399 29.9171 20.0399 29.263C20.0399 23.5039 15.3504 18.8192 9.58659 18.8192C8.93247 18.8192 8.40159 18.2883 8.40159 17.6342C8.40159 16.9801 8.93247 16.4492 9.58659 16.4492C16.6571 16.4492 22.4099 22.1972 22.4099 29.263C22.4099 29.9171 21.879 30.448 21.2249 30.448ZM15.4215 30.448C14.7674 30.448 14.2365 29.9171 14.2365 29.263C14.2365 26.7018 12.1493 24.6178 9.58501 24.6178C8.93089 24.6178 8.40001 24.0869 8.40001 23.4328C8.40001 22.7787 8.93089 22.2478 9.58501 22.2478C13.456 22.2478 16.6066 25.3952 16.6066 29.263C16.6066 29.9171 16.0757 30.448 15.4215 30.448ZM9.71457 30.7008C8.83451 30.7008 8.11719 29.9851 8.11719 29.105C8.11719 28.2249 8.83451 27.5092 9.71457 27.5092C10.5962 27.5092 11.3135 28.2249 11.3135 29.105C11.3135 29.9851 10.5962 30.7008 9.71457 30.7008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouterLogin);
export default __webpack_public_path__ + "static/media/router-login.ab0edccfff8e4d4345dcddf43a5be4f9.svg";
export { ForwardRef as ReactComponent };